export const FALLBACK_SUCCESS = 0;
export const FALLBACK_ERROR = 1;
